
/// <reference types="jquery" />

declare var Swal: any;
declare function fncFormatInputs(): void;
declare function fncSweetAlert(type: string, text: string, url?: string | null): void;

/*=============================================
Función para formatear Inputs
=============================================*/

function fncFormatInputsGlobal() {

    if (window.history.replaceState) {
        window.history.replaceState(null, null, window.location.href);
    }

}

$(document).ready(function () {

    $('button[data-bs-toggle="modal"]').on('click', function (this: HTMLElement) {
        // Obtener el valor del atributo 'plan'
        var planValue = $(this).attr('plan');
        var planPrice = $(this).attr('price');
        console.log(planValue)
        // Asignar el valor al input del modal
        $('#plan_demo').val(planValue);
        $('#plan_user').val(planValue);
        $('#price_user').val(planPrice);
    });

    $("#formDemo").on("submit", function (event: JQuery.SubmitEvent) {
        event.preventDefault();

        var formDemo = $("#formDemo").get(0) as HTMLFormElement;
        var formData = new FormData(formDemo);
        formData.append("newDemo", "true");

        $.ajax({
            url: "ajax/ajax.demo.php",
            method: "POST",
            data: formData,
            contentType: false,
            cache: false,
            processData: false,
            dataType: "json",
            success: function (response: { status: number }) {
                console.log(response)
                if (response.status == 200) {
                    ($('#formDemo')[0] as HTMLFormElement).reset();

                    ($("#btndemo") as any).modal('toggle');
                    fncFormatInputs();
                    fncSweetAlert("alert", "Tú Solicitud fue enviada correctamente", "success");
                } else {
                    fncSweetAlert("error", "No se envio la solicitud, porfavor reintentar", null);
                }
            }
        });
    });


    // Modal Step Logic
    let currentStep = 1;

    function showStep(step: number) {
        $('#step1, #step2, #step3, #stepSuccess').hide();
        $('#step' + step).show();
        currentStep = step;

        // Update modal title based on step
        const titles = {
            1: "Completa tus datos",
            2: "Realizar Pago",
            3: "Confirmar Pago"
        };
        $('#modalTitle').text(titles[step as keyof typeof titles] || "");
    }


    // Reset modal when closed
    $('#modalPlan').on('hidden.bs.modal', function () {
        showStep(1);
        ($('#formSalePlan')[0] as HTMLFormElement).reset();
    });

    // Step 1 -> Step 2
    $('#btnNext1').on('click', function () {
        // Simple validation
        const name = $('input[name="name_user"]').val();
        const email = $('input[name="email_user"]').val();
        const phone = $('input[name="phone_user"]').val();

        if (name && email && phone) {
            showStep(2);
        } else {
            fncSweetAlert("error", "Por favor completa todos los campos", null);
        }
    });

    // Step 2 -> Step 3
    $('#btnNext2').on('click', function () {
        // Populate Summary
        const name = $('input[name="name_user"]').val();
        // const email = $('input[name="email_user"]').val();
        const price = $('#price_user').val();
        const method = 'Yape'; // Default to Yape

        $('#summaryName').text(`${name}`);
        $('#summaryAmount').text(`S/ ${price}`);
        $('#summaryMethod').text(method);

        showStep(3);
    });

    // Back buttons
    $('#btnBack1').on('click', function () {
        showStep(1);
    });

    $('#btnBack2').on('click', function () {
        showStep(2);
    });

    // Copy Number Button
    $('#btnCopyNumber').on('click', function () {
        const number = $('#paymentNumber').val() as string;
        navigator.clipboard.writeText(number).then(() => {
            const originalText = $(this).text();
            $(this).text('¡Copiado!');
            $(this).removeClass('btn-outline-secondary').addClass('btn-success');
            setTimeout(() => {
                $(this).text(originalText);
                $(this).removeClass('btn-success').addClass('btn-outline-secondary');
            }, 2000);
        });
    });

    $("#formSalePlan").on("submit", function (event: JQuery.SubmitEvent) {
        event.preventDefault();

        var formSalePlan = $("#formSalePlan").get(0) as HTMLFormElement;
        var formData = new FormData(formSalePlan);
        formData.append("newPlan", "true");

        var now = new Date();
        var dateString = now.getFullYear() + '-' +
            String(now.getMonth() + 1).padStart(2, '0') + '-' +
            String(now.getDate()).padStart(2, '0') + ' ' +
            String(now.getHours()).padStart(2, '0') + ':' +
            String(now.getMinutes()).padStart(2, '0') + ':' +
            String(now.getSeconds()).padStart(2, '0');

        formData.append("date", dateString);

        $.ajax({
            url: "/submit/plan",
            method: "POST",
            data: formData,
            contentType: false,
            cache: false,
            processData: false,
            dataType: "json",
            success: function (response: any) {
                console.log("Response from server:", response);
                console.log("jsPDF available:", (window as any).jspdf);

                if (response.status == 201) {
                    // Hide previous steps
                    $('#step3').hide();
                    
                    // Populate success modal
                    $('#successUser').text(response.data.username);
                    $('#successPass').text(response.data.password);
                    $('#successPlan').text(response.data.plan);
                    $('#successPrice').text(response.data.price);
                    $('#successExpiration').text(response.data.expiration);

                    // Show success step
                    $('#stepSuccess').show();
                    $('#modalTitle').text("¡Suscripción Exitosa!");

                    // Handle PDF Download
                    $('#btnDownloadPDF').off('click').on('click', function() {
                        const { jsPDF } = (window as any).jspdf;
                        const doc = new jsPDF();

                        doc.setFontSize(22);
                        doc.setTextColor(40, 167, 69); // Green color
                        doc.text("Constancia de Suscripción", 105, 20, { align: "center" });

                        doc.setFontSize(16);
                        doc.setTextColor(0, 0, 0);
                        doc.text("Internet WatsonTIC", 105, 30, { align: "center" });

                        doc.setFontSize(12);
                        doc.text("Usuario: " + response.data.username, 20, 50);
                        doc.text("Contraseña: " + response.data.password, 20, 60);
                        doc.text("Plan: " + response.data.plan, 20, 70);
                        doc.text("Precio: S/ " + response.data.price, 20, 80);
                        doc.text("Fecha de Expiración: " + response.data.expiration, 20, 90);

                        doc.text("Gracias por su preferencia.", 105, 110, { align: "center" });

                        doc.save("constancia_watsontic_" + response.data.username + ".pdf");
                    });

                } else {
                    fncSweetAlert("error", "No se envio la solicitud, porfavor reintentar", null);
                }
            }
        });
    });

    if ($(".owl-carousel").length > 0 && typeof ($(".owl-carousel") as any).owlCarousel === 'function') {
        ($(".owl-carousel") as any).owlCarousel({
            loop: false,
            margin: 10,
            responsiveClass: true,
            autoplay: true,
            autoplayTimeout: 3500,
            autoplayHoverPause: false,
            responsive: {
                0: {
                    items: 1,
                    nav: false
                },
                600: {
                    items: 2,
                    nav: false
                },
                1000: {
                    items: 3,
                    nav: false,
                },
                1400: {
                    items: 4,
                    nav: false,
                }
            }
        });
    }

    // Forgot Password Logic
    $("#formForgotpassword").on("submit", function (event: JQuery.SubmitEvent) {
        event.preventDefault();
        // Form Validation
        const email = $('input[name="emailForgot"]').val();
        if (!email) {
            fncSweetAlert("error", "Por favor ingrese su correo electrónico", null);
            return;
        }

        var form = $(this);
        var formData = new FormData(form[0] as HTMLFormElement);

        $.ajax({
            url: "/auth/auth-forgot-password",
            method: "POST",
            data: formData,
            contentType: false,
            cache: false,
            processData: false,
            dataType: "json",
            success: function (response: any) {
                if (response.status == 200 || response.success === true) {
                    fncSweetAlert("success", response.message, "/login");
                } else {
                    fncSweetAlert("error", response.message || "Error al enviar la solicitud", null);
                }
            },
            error: function () {
                fncSweetAlert("error", "Error inesperado al procesar la solicitud", null);
            }
        });
    });
    // Reset Password Logic
    $("#formResetPassword").on("submit", function (event: JQuery.SubmitEvent) {
        event.preventDefault();

        // Validation
        const password = $('input[name="password_user"]').val();
        const confirmPassword = $('input[name="confirm-password"]').val();

        if (!password || !confirmPassword) {
            fncSweetAlert("error", "Por favor complete todos los campos", null);
            return;
        }

        if (password !== confirmPassword) {
            fncSweetAlert("error", "Las contraseñas no coinciden", null);
            return;
        }

        var form = $(this);
        var formData = new FormData(form[0] as HTMLFormElement);

        $.ajax({
            url: "/auth/auth-reset-password",
            method: "POST",
            data: formData,
            contentType: false,
            cache: false,
            processData: false,
            dataType: "json",
            success: function (response: any) {
                if (response.status == 200 || response.success === true) {
                    fncSweetAlert("success", response.message, "/login");
                } else {
                    fncSweetAlert("error", response.message || "Error al restablecer la contraseña", null);
                }
            },
            error: function () {
                fncSweetAlert("error", "Error inesperado al procesar la solicitud", null);
            }
        });
    });
    /*=============================================
    Registro del Service Worker
    =============================================*/
    if ('serviceWorker' in navigator) {
        window.addEventListener('load', function () {
            navigator.serviceWorker.register('/sw.js')
                .then(function (reg) {
                    console.log('Service Worker registrado correctamente', reg);
                })
                .catch(function (err) {
                    console.warn('Error al registrar el Service Worker', err);
                });
        });
    }
});
